import React from 'react';
import { TextField } from '@mui/material';

const Step4 = ({ formData, setFormData, errors, setErrors }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
  };

  return (
    <>
      <span className='top-text mb-25'>
        განაცხადის მიღების შემდეგ, დამატებითი კითხვების შემთხვევაში, მოხდება
        თქვენთან დაკავშირება. ინფორმაცია გამცხადებლის შესახებ
      </span>

      <div>
        <span>სახელი (სავალდებულო)*</span>
        <TextField
          fullWidth
          label='შეიყვანეთ სახელი'
          name='firstName'
          value={formData.firstName || ''}
          onChange={handleChange}
          error={!!errors.firstName}
          helperText={errors.firstName}
        />
      </div>

      <div>
        <span>გვარი (სავალდებულო)*</span>
        <TextField
          fullWidth
          className='mb-20-mt-10'
          label='შეიყვანეთ გვარი'
          name='lastName'
          value={formData.lastName || ''}
          onChange={handleChange}
          error={!!errors.lastName}
          helperText={errors.lastName}
        />
      </div>

      <div>
        <span>ორგანიზაცია</span>
        <TextField
          fullWidth
          className='mb-20-mt-10'
          label='შეიყვანეთ ორგანიზაცია'
          name='organization'
          value={formData.organization || ''}
          onChange={handleChange}
        />
      </div>

      <div>
        <span>ელ-ფოსტა (სავალდებულო)*</span>
        <TextField
          fullWidth
          className='mb-20-mt-10'
          type='email'
          label='შეიყვანეთ ელ-ფოსტა'
          name='email'
          value={formData.email || ''}
          onChange={handleChange}
          error={!!errors.email}
          helperText={errors.email}
        />
      </div>

      <div>
        <span>ტელეფონი (სავალდებულო)*</span>
        <TextField
          fullWidth
          className='mb-20-mt-10'
          type='tel'
          label='შეიყვანეთ ტელეფონი'
          name='phone'
          value={formData.phone || ''}
          onChange={handleChange}
          error={!!errors.phone}
          helperText={errors.phone}
        />
      </div>

      <div>
        <span>მისამართი</span>
        <TextField
          fullWidth
          className='mb-20-mt-10'
          label='შეიყვანეთ მისამართი'
          name='address'
          value={formData.address || ''}
          onChange={handleChange}
        />
      </div>

      <div>
        <span>ქალაქი</span>
        <TextField
          fullWidth
          className='mb-20-mt-10'
          label='შეიყვანეთ ქალაქი'
          name='city'
          value={formData.city || ''}
          onChange={handleChange}
        />
      </div>
    </>
  );
};

export default Step4;
